//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from "@angular/core";
import { 
  ActivatedRoute, 
  Router 
} from "@angular/router";

//local imports
import { DepartmentModel } from "@app/catalog";
import { PresenterType } from "@app/shared";

@PresenterType({
  model: DepartmentModel,
  key: 'tileBottom'
})
@Component({
  selector: 'department-carousel-item-bottom',
  standalone: false,
  templateUrl: './department-carousel-item-bottom.component.html',
  styleUrl: './department-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentCarouselItemBottomComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public data: WritableSignal<DepartmentModel> =
    signal<DepartmentModel>(undefined);

  public navigateToDetailPage() {
    this.router.navigate(["department", this.data().id], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
    });
  }
}
